module.exports = __webpack_public_path__ + "img/linejki.c2b855dc.svg";